import { useRef, useState, useEffect } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { ToastContainer, toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useQuery } from "react-query";
import axios from "axios";

const Main = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedServer, setSelectedServer] = useState("SUNSET Clothe");
  const [selectedSex, setSelectedSex] = useState("all");
  const [selectedCard, setSelectedCard] = useState(null);
  const [infoMenu, setInfoMenu] = useState(null);
  const cardRef = useRef();
  const menuRef = useRef();
  const {
    data: model,
    error,
    isLoading,
    isError,
  } = useQuery("model", async () => {
    const { data } = await axios.get("https://cdn.sunrp.ir/jornal.json");

    return data;

    // return [
    //   {
    //     sex: "female",
    //     category: "1",
    //     name: "mp_f_freemode_01_mp_f_bikerdlc_01_accs_007",
    //     url: "https://cdn.sunrp.ir/img/jornal_files/mp_f_freemode_01_mp_f_bikerdlc_01_accs_007.rar",
    //     description: " ",
    //     server: "sunset",
    //   },

    //   {
    //     sex: "male",
    //     category: "1",
    //     name: "mp_m_freemode_01_mp_m_bikerdlc_01_accs_007",
    //     url: "https://cdn.sunrp.ir/img/jornal_files/mp_m_freemode_01_mp_m_bikerdlc_01_accs_007.rar",
    //     description: " ",
    //     server: "default",
    //   },
    //   {
    //     sex: "male",
    //     category: "2",
    //     name: "mp_m_freemode_01_male_heist_uppr_065",
    //     url: "https://cdn.sunrp.ir/img/jornal_files/mp_m_freemode_01_male_heist_uppr_065.rar",
    //     description: " ",
    //     server: "sunset",
    //   },
    // ];
  });

  const categories = model
    ? Array.from(
        new Set(
          model
            .filter((m) => selectedServer === "all" || m.server === selectedServer)
            .map((m) => m.category)
        )
      )
    : [];

  const svcategories = model
    ? Array.from(new Set(model.map((m) => m.server)))
    : [];

  useEffect(() => {
    setSelectedCategory("all");
  }, [selectedServer]);

  const notif = (msg) => {
    toast(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Flip,
    });
  };

  if (isError) {
    return (
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
        <h1 className="text-xl text-red-600">ERROR TO FETICHING</h1>
        <p>{error}</p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center flex-col z-50">
        <div className="w-20 h-20 border-t-2 border-b-2 border-purple-600 animate-spin rounded-full"></div>
        <p className="mt-5 text-purple-500 text-lg">Fetching Data ...</p>
      </div>
    );
  }

  const filteredModel = model.filter(
    (m) =>
      m.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedCategory === "all" || m.category === selectedCategory) &&
      (selectedSex === "all" || m.sex === selectedSex) &&
      (selectedServer === "all" || m.server === selectedServer)
  );
  const CopyHandel = (text) => {
    navigator.clipboard.writeText(text);
    notif("model text Copied");
  };

  const CloseHandel = () => {
    if (selectedCard) {
      setSelectedCard(null);
    }
    if (infoMenu) {
      setInfoMenu(null);
    }
  };

  return (
    <div
      className="flex w-full items-center flex-col"
      onClick={() => CloseHandel()}
    >
      <ToastContainer />
      <header className="z-20 px-5 flex justify-center flex-wrap sm:justify-between items-center w-full md:w-11/12 bg-zinc-600/40 shadow-lg backdrop-blur-lg h-[150px] sm:h-[75px] rounded-lg fixed top-5 border-[#3d1776] border border-dashed">
        <div className="flex items-center">
          <p className="font-bold text-lg md:text-xl text-gray-200 animate-pulse">
            <span className="text-purple-700">SUN CO</span> JORNAL
          </p>

          <FaInfoCircle
            onClick={() => setInfoMenu(true)}
            className="size-6 ml-2 text-purple-700 hover:scale-110 transition-all duration-200 cursor-pointer"
          />
        </div>
        <input
          type="text"
          className="input w-[200px] md:w-[300px] mt-2 md:mt-0"
          placeholder="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="flex flex-wrap mt-2 md:mt-0">
          <select
            className="input mr-2"
            value={selectedServer}
            onChange={(e) => setSelectedServer(e.target.value)}
          >
            <option value="all">All Servers</option>
            {svcategories.map((server, index) => (
              <option key={index} value={server}>
                {server}
              </option>
            ))}
          </select>

          <select
            className="input mr-2"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
          <select
            className="input mr-2"
            value={selectedSex}
            onChange={(e) => setSelectedSex(e.target.value)}
          >
            <option value="all">All Sex</option>
            <option value="female">Female</option>
            <option value="male">Male</option>
          </select>
        </div>
      </header>

      <div
        className={`flex justify-center flex-wrap mt-[200px] sm:mt-[120px] w-11/12 transition-all duration-200 ${
          selectedCard !== null ? "blur-sm" : ""
        }`}
      >
        {filteredModel.map((m, index) => (
          <div
            key={index}
            className="m-3 hover:scale-105 transition-all duration-200 p-2 w-[310px] h-[270px] bg-zinc-600/20 shadow-lg backdrop-blur-lg rounded-xl border border-dashed border-purple-500"
          >
            <div className="w-full">
              <img
                src={`https://cdn.sunrp.ir/img/thumbnails/${m.name}.png`}
                loading="lazy"
                alt=""
                className="w-full rounded-xl cursor-pointer"
                onClick={() => setSelectedCard(m)}
              />
            </div>
            <div className="w-full mt-8 flex justify-between">
              <h1
                className="text-center text-sm font-bold break-words overflow-hidden text-clip max-h-12 hover:text-purple-600 cursor-pointer"
                onClick={() => CopyHandel(m.name)}
              >
                {m.name}
              </h1>
            </div>
          </div>
        ))}
      </div>

      {selectedCard && (
        <div
          className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
          onClick={() => setSelectedCard(null)}
        >
          <div
            className="bg-zinc-900 p-6 rounded-lg max-w-3xl w-full relative"
            ref={cardRef}
            onClick={(e) => e.stopPropagation()}
          >
            <IoIosCloseCircleOutline
              className="size-10 text-red-500 hover:scale-110 transition-all duration-200"
              onClick={() => setSelectedCard(null)}
            />
            <div className="w-full my-5">
              <img
                src={`https://cdn.sunrp.ir/img/jornal/${selectedCard.name}.png`}
                loading="lazy"
                alt=""
                className="w-full rounded-xl"
              />
            </div>
            <div className="mt-5">
              <h1
                className="my-5 text-lg font-bold text-center animate-pulse hover:text-purple-500 transition-all duration-200 cursor-pointer"
                onClick={() => CopyHandel(selectedCard.name)}
              >
                {selectedCard.name}
              </h1>
              <div className="flex w-full justify-between">
                <div>
                  <p className="mt-2 text-purple-500">
                    Category :{" "}
                    <span className="font-bold text-white">
                      {selectedCard.category}
                    </span>
                  </p>
                  <p className="mt-2 text-purple-500">
                    Sex :{" "}
                    <span className="font-bold text-white">
                      {selectedCard.sex}
                    </span>
                  </p>
                </div>
                {selectedCard.url ? (
                  <div className="mt-5 text-center hover:scale-90 duration-150 transition-all">
                    <a
                      href={selectedCard.url}
                      download
                      className="input cursor-pointer"
                    >
                      Download
                    </a>
                  </div>
                ) : null}
              </div>

              {selectedCard.description ? (
                <div className="mt-5 w-full text-right border-dashed border border-purple-500 rounded-md p-2 max-h-[150px] overflow-auto">
                  <h1 className="font-[Vazir] font-bold text-xl">:توضیحات</h1>
                  <p className="font-[Vazir] mt-4 ">
                    {selectedCard.description}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}

      {infoMenu ? (
        <div
          className="fixed inset-0 bg-black/40 flex justify-center  z-50"
          onClick={() => setSelectedCard(null)}
        >
          <div
            className="h-[150px] mt-[200px] md:mt-[100px] bg-zinc-900 px-3 py-4 rounded-lg max-w-xl w-full relative flex flex-col font-[vazir] border border-purple-600"
            ref={menuRef}
            onClick={(e) => e.stopPropagation()}
          >
            <IoIosCloseCircleOutline
              className="size-7 text-red-500 hover:scale-110 transition-all duration-200"
              onClick={() => setInfoMenu(null)}
            />
            <div className="w-full text-right">
              <p>
                برای گزارش باگ و فایل های دانلود به تاپیک{" "}
                <a
                  href="https://forum.vmp.ir/t/vmp/5014"
                  className="text-cyan-500 font-bold"
                >
                  وی ام پی{" "}
                </a>
                مراجعه کنید{" "}
              </p>
              <p className="text-gray-300 mt-2">
                <a
                  href="https://tobii.space/"
                  className="text-cyan-500 font-bold"
                >
                  tobi
                </a>{" "}
                مرجع عکس
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Main;
